export default {
    // アプリ個別の定義
    main: {
        menu: {
            trials: 'TRIALS',
        },
        translate: {
            ja: '日本語',
            en: 'English',
        },
    },
    trials: {
        help00: {
            //common all reset
            create_kc: 'Reset all uploaded data and return to Step 1-1.',
        },
        help01: {
            //common table's help
            create_kc: 'The "Label" column shows whether each row meets the criteria.<br>1 means POS, a positive result,<br>while 0 means NEG, a negative result.',
        },
        help02: {
            //Step 1 button
            create_kc: 'Generate combinations of important items based on the data for learning.',
        },
        help03: {
            //Step 1 button
            create_kc: 'Clear the uploaded data for learning,<br>and return to the screen for uploading new data.',
        },
        help04: {
            //Step 2 button
            create_kc: 'Weigh "important combinations",<br>and prepare the data for use in determining associations.',
        },
        help05: {
            //common chart's help
            create_kc: 'POS indicates positive associations,<br>while NEG indicates negative associations.',
        },
        help06: {
            //Step 3 button
            create_kc: 'Begin preprations for prediction.',
        },
        help07: {
            //Step 4 button
            create_kc: 'Begin prediction.',
        },
        help08: {
            //Step 4 clear button
            create_kc: 'Clear the uploaded data for prediction,<br>and return to the screen for uploading new data.',
        },
        title: 'Wide Learning™ Trial Tool - Hello, Wide Learning!',
        header: {
            logo: {
                img: '/assets/image/logo_en.svg',
                url: '/en/index.html',
            },
            home: {
                text: 'Home',
                url: '/en/index.html',
            },
            example: {
                text: 'Application (in Japanese)',
                url: '/ja/examples/index.html',
            },
            whats_wl: {
                text: 'What is Wide Learning&trade;?',
                url: '/en/whatsWL/index.html',
            },
            about_us: {
                text: 'About Us',
                url: '/en/aboutUs/index.html',
            },
            trial_tool: {
                text: 'Trial Tool',
                url: '/en/trialTool/index.html',
            }
        },
        footer: {
            home: {
                text: 'Home',
                url: '/en/index.html',
            },
            example: {
                text: 'Application (in Japanese)',
                url: '/ja/examples/index.html',
            },
            whats_wl: {
                text: 'What is Wide Learning&trade;?',
                url: '/en/whatsWL/index.html',
            },
            casestudy01: {
                text: 'Case Study: Identifying Mammals',
                url: '/en/whatsWL/casestudy01.html',
            },
            casestudy02: {
                text: 'Case Study: Discovery of Electoral Factors',
                url: '/en/whatsWL/casestudy02.html',
            },
            casestudy03: {
                text: 'Case Study: Analysis of COVID-19 Policies',
                url: '/en/whatsWL/casestudy03.html',
            },
            about_us: {
                text: 'About Us',
                url: '/en/aboutUs/index.html',
            },
            trial_tool: {
                text: 'Trial Tool',
                url: '/en/trialTool/index.html',
            },
            privacy: {
                text: 'Privacy Policy',
                url: '/en/privacy.html',
            },
            contact: {
                text: 'Contact Us',
                url: '/en/contact/link.html',
            },
        },
        menu: {
            cheat_sheet: {
                label: 'Cheat sheet',
                img_url_train_data: '/trials/images/step_1-2_en.svg',
                img_url_train_result: '/trials/images/step_3_en.svg',
                img_url_predict_data: '/trials/images/step_4_en.svg',
                img_url_predict_result: '/trials/images/step_5_en.svg',
            },
            reset: 'Reset',
            step1: {
                label: '<span class="stepNumber1">Step:1</span>Let\'s prepare<br>data for learning!',
                step1: {
                    label: '<span class="stepNumber1_1">1-1</span>Upload<br>data for learning',
                },
                step2: {
                    label: '<span class="stepNumber1_2">1-1</span>Check the uploaded data',
                },
                step3: {
                    label: '<span class="stepNumber1_3">1-3</span>Check the<br>data for learning',
                },
                button: {
                    create_kc: 'Proceed to Step 2',
                    creating_kc: 'Generating combinations',
                    format: 'Clear data for learning',
                },
            },
            step2: {
                label: '<span class="stepNumber2">Step:2</span>Let\'s check the<br>combinations of<br>important items!',
                step1: {
                    label: '<span class="stepNumber2_1">2-1</span>List of important combinations',
                },
                button: {
                    start_training: 'Proceed to Step 3',
                    training: 'Now weighting',
                },
            },
            step3: {
                label: '<span class="stepNumber3">Step:3</span>Let\'s check the<br>results of learning!',
                step1: {
                    label: '<span class="stepNumber3_1">3-1</span>Overall learning results',
                    button: {
                        to_all: 'Return to Overall Learning Results',
                        to_params: 'Check the evaluation values of the learning results here',
                        to_params_prefix: '[Intermediate users]',
                    },
                },
                step2: {
                    label: '<span class="stepNumber3_2">3-2</span>Individual<br>Learning Results',
                },
                button: {
                    next: 'Proceed to Step 4',
                },
            },
            step4: {
                label: '<span class="stepNumber4">Step:4</span>Let\'s prepare<br>data for prediction!',
                step1: {
                    label: '<span class="stepNumber4_1">4-1</span>Upload data <br> for prediction',
                },
                step2: {
                    label: '<span class="stepNumber4_2">4-1</span>Check the uploaded data',
                },
                step3: {
                    label: '<span class="stepNumber4_3">4-3</span>Check the<br>data for prediction',
                },
                button: {
                    start_predict: 'Proceed to Step 5',
                    predicting: 'Predicting',
                    format: 'Clear Prediction Data',
                },
            },
            step5: {
                label: '<span class="stepNumber5">Step:5</span>Let\'s check the<br>results of prediction',
                step1: {
                    label: '<span class="stepNumber5_1">5-1</span>Individual<br>prediction results',
                },
            },
        },
        note: {
            step1: {
                text: 'Google Chrome is the recommended browser.',
                url: '/en/trialTool/index.html',
            },
        },
        description: {
            step1: {
                step1: {
                    before:
                        'Upload the CSV file containing the data for learning.<br>Please drag and drop or pull down the file into the space below.<br>If you do not have CSV file on your computer, it can be downloaded from the link below.<br>Drag and drop the file containing the data for learning here.',
                },
                step2:
                    'The uploaded training data is displayed. In data for learning, there is an item indicating the "Correct Answer Label" in the rightmost column.<br>In Wide Learning&trade; it is indicated as;<span class="negativeLabel">0 → NEG</span>, <span class="positiveLabel">1 → POS</span>.',
                step3: {
                    all: 'The number of 0\'s (NEG) and 1\'s (POS) of the data for learning is displayed.',
                    labels:
                        'This graph shows the totals of the values for each item.<br>0 (NEG) and 1 (POS) are split and displayed using different colors.',
                    na:
                        'The numbers and percentages of missing values (Empty value) are displayed for each item.',
                },
                creating_kc:
                    'Generating combinations of important items.<br>Please wait for the process to complete.',
                finish_create_kc: 'Created combinations of important items.',
            },
            step2: {
                step1:
                    'Based on the data for learning, Wide Learning&trade; generated combinations of important items and values.',
                training: 'Weighting important combinations.',
            },
            step3: {
                step1: {
                    all:
                        'The importance (weight) is calculated to indicate how important<br> the "combinations of important items" that occurred in Step 2 is in determining whether the data is 0 (NEG) or 1 (POS).',
                    params:
                        'The table below shows the Wide Learning&trade; evaluation values. This is the result of dividing the data for learning entered in Step 1 into three equal parts, using two of them for learning, and evaluating the other one (See the figure below).<br>In the prediction in Step 5, all of the data for learning are learned, and prediction is performed using the data for prediction input in Step 4.',
                    img_url: '/trials/images/step3_dataImg_en.svg',
                },
                step2: {
                    before:
                        "You can see how each row of data for learning fits together. Let's click a row.",
                },
            },
            step4: {
                step1: {
                    before: 'Upload the CSV file containing the data for prediction.<br>Drag and drop or pull down the file into the space below.<br>If you do not have CSV file on your computer, it can be downloaded from the link below.',
                },
                step2: 'The data for prediction that has been uploaded is displayed.',
                step3: {
                    labels:
                        'The numbers of rows for each value for the item are displayed.',
                    na:
                        'The numbers and percentages of missing values (Empty value) are displayed for each item.',
                },
                predicting: 'Now predicting. <br>Please wait for the process to complete.',
                finish_predicting: 'Predicting is complete.',
            },
            step5: {
                step1: {
                    before:
                        'The results show whether the data for prediction has been determined to be 0(NEG) or 1(POS).<br>When you click a row, the "combination of important items" that determined the classification are displayed on the right.<br>You have reached the end of the Trial Tool. Thank you for using Wide Learning&trade;',
                },
            },
        },
        tos: {
            agree: 'agree',
        },
        input: {
            train: 'Data for Learning',
            predict: 'Data for Prediction',
            message: 'Drag & Drop',
            csvSelection: 'Select case study data',
            downloads: {
                mammalian: {
                    text: 'Download the sample data (Identifying Mammals) from here.',
                    url: '/en/trialTool/index.html',
                },
            },
            error: {
                text: 'If you get errors while using the Trial Tool, click here.',
                url: '/en/trialTool/faq.html#faq006',
            },
        },
        caption: {
            data: {
                tabs: {
                    all: 'All',
                    na: '(NA)',
                    labels: 'Labels',
                },
                na: {
                    labels: 'Labels',
                    count: 'Count',
                    ratio: 'Ratio',
                },
            },
            results: {
                menu: {
                    score: 'Parameters and Scores',
                    knowledge_chunk: 'Knowledge Chunks',
                    data: 'Data',
                    go_predict: 'Use This Model',
                },
                score: {
                    evaluation_metrics: 'Model Evaluation Indicators',
                    evaluation_value: 'Evaluation Value',
                    score: 'Score',
                    result: 'Result',
                    fvalue: {
                        label: 'F-Value',
                        description:
                            'A measure of the outcome of the predictiont.<br>It is defined by the harmonic mean of reproducibility and goodness-of-fit.',
                    },
                    precision: {
                        label: 'Prediction',
                        description:
                            'Percentage of predicted positive data that is actually positive.',
                    },
                    recall: {
                        label: 'Recall',
                        description:
                            'Proportion of those actually positive that were predicted to be positive.',
                    },
                },
                knowledge_chunk: {
                    chunk: 'Combination of important items',
                    summary: 'Summary',
                    weight: 'importance (weight)',
                    support: 'Support',
                    confidence: 'Confidence',
                    len: 'Combination Length',
                    npos: 'occurrences of POS',
                    nneg: 'occurrences of NEG',
                    pos: 'POS',
                    neg: 'NEG',
                },
                data: {
                    before: 'Binary',
                    after: 'Original',
                    no_select: 'Please select data from the table on the left.',
                    no_data_pos: 'Unable to find enough combinations for the selected row.<br>The prediction for it is determined to be <span class="positiveLabel">positive</span> by the overall trend.',
                    no_data_neg: 'Unable to find enough combinations for the selected row.<br>The prediction for it is determined to be <span class="negativeLabel">negative</span> by the overall trend.',
                },
            },
        },
        dialog: {
            button: {
                close: 'Close',
                yes: 'Yes',
                no: 'No',
            },
            contents: {
                format: {
                    all: {
                        title: 'Perform Initialization',
                        message: 'All data will be deleted. Is that OK?',
                    },
                    predict: {
                        title: 'Initialize Data for Prediction',
                        message: 'Data for prediction will be deleted. Is that OK?',
                    },
                },
                start: {
                    creating_kc: {
                        title: 'Generate combinations of important items',
                        message:
                            'Generates key item combinations.<br>After combinations are generated, the process will automatically shift to Step 2. Is that OK?',
                    },
                    training: {
                        title: 'Weight important combinations',
                        message:
                            'Weight important combinations.<br>After the weighting is completed, the process will automatically shift to Step 3. Is that OK?',
                    },
                    predict: {
                        title: 'Start Prediction',
                        message:
                            'Start Prediction.<br>After the prediction is completed, the procedure will automatically shift to Step 5. Is that OK?',
                    },
                },
            },
        },
    },
    contact: {
        title: 'Contact Us - Hello, Wide Learning!',
        fields: {
            subject: 'Subject',
            message: 'Inquiry Details',
            relatedContent: 'Your Reason for Accessing the Site (Web site URLs, lecture names, articles, search keywords, etc.)',
            name: 'Name',
            email: 'Contact Details (Email Address)',
            company: 'Affiliation (Company/School Name)',
            agree: 'Agreement Checkbox',
        },
        placeholders: {
            subject: 'Please enter the subject.',
            message: 'Please enter the details of your inquiry.',
            relatedContent: 'Please provide us with the reason for your visiting our site (Web site URLs, lecture names, articles, search keywords, etc.).',
            name: 'Please enter your name.',
            email: 'Please enter your contact details (email address).',
            company: 'Please enter your affiliation (Company/school name).',
        },
        form: {
            title: 'Inquiry Form',
            notes: [
                'All fields marked with "<span class="ic-required">*</span>" must be entered.',
                'Single-byte katakana and machine-dependent characters cannot be used.',
            ],
            inquiryTitle: 'Inquiry Details',
            policyTitle: 'Handling of Personal Information',
            policies: [
                'The personal information provided on this site is used for the purpose of responding to inquiries. Depending on the content of your inquiry, we may request Fujitsu Limited or a Fujitsu Group Company to respond after providing them with the content of your inquiry and your contact information.',
                'We will handle your personal information appropriately in accordance with the <a href="https://www.fujitsu.com/global/about/resources/privacy/" target="_blank" rel="noopener noreferrer">Privacy (Personal Information Protection) Policy of Fujitsu Limited</a>.',
                'If you wish to request disclosure, correction, addition, deletion, or discontinuance of use of information, please contact us by email at the following contact address.',
            ],
            contactInformation: {
                title: 'Inquiries regarding this matter',
                depertment: 'Fujitsu Research FUJITSU LIMITED, Hello, Wide Learning! Site Contact',
                address: 'Address: Kamikodanaka 4-1-1, Nakahara-ku, Kawasaki, Kanagawa, 211 -8588',
            },
            eea: {
                title: 'If you are located in an EEA (European Economic Area) Member Country, please check the following precautions and then contact us at the following address. If you are under 16 years old, please contact us only after obtaining the consent of your guardian.',
                depertment: 'Fujitsu Research FUJITSU LIMITED, Hello, Wide Learning! Site Contact',
                notice_caption: 'Precautions:',
                notices: [
                    "This e-mail address is used to receive inquiries from customers regarding Fujitsu Researches' research activities. However, this email address is not for use by people located outside of the EEA Member Countries. Please fill out the inquiry form on this page.",
                    'Please specify your name, affiliation, email address, country of location, and describe the details of your inquiry. Also, please include the reason for your visiting our site (Web site URLs, lecture names, articles, search keywords, etc.). Please note that we will not be able to respond if you do not provide your country of location.',
                    "Anything submitted to this email address will be treated as the sender has given their consent for it to be forwarded to Japan and stored on Fujitsu's servers in Japan. As of January 23, 2019, Japan has been certified by the European Commission as being fully qualified (GDPR Article 45 Transfers on the basis of an accuracy decision). We will transfer your personal information to Japan based on our Sufficiency Assessment.",
                    'The personal information provided using this email address is used for the purpose of responding to inquiries. Depending on the content of your inquiry, we may request Fujitsu Limited or a Fujitsu Group Company to respond after providing them with the content of your inquiry and your contact information.',
                    'We will handle your personal information appropriately in accordance with the <a href="https://www.fujitsu.com/global/about/resources/privacy/" target="_blank" rel="noopener noreferrer">Privacy (Personal Information Protection) Policy of Fujitsu Limited</a> for six months after responding to your inquiry.',
                    'You may withdraw your agreement at any time. Customers have rights that include "right of access", "right of correction", "right of erasure", "right to restrict handling", "right to data portability", "right to automated individual judgment", and "right to object". If you wish to exercise your rights, please contact us by mail at the following address.',
                ],
                addition: 'If you are dissatisfied with our response, you may file a complaint with the supervisory authority.',
            },
            agree: 'I agree to the policy below regarding handling of personal information.',
            next: 'Proceed to the confirmation screen',
        },
        confirmation: {
            title: 'Confirm the details of your inquiry',
            back: 'Change the details',
            send: 'Send',
            error: 'Unfortunately, sending of your inquiry failed.',
        },
        finish: {
            title: 'Inquiry Complete',
            blockTitle: 'Inquiry Complete',
            message: 'Thank you for your inquiry.',
        },
    },
    error: {
        title: 'An error occurred',
        message: {
            default: 'Please try again from the beginning.',
            retry: 'Please try again.',
            nodata: 'Data not found.',
            unauthorized:
                'A certain period of time has passed since the start of use.<br>Please try again from the beginning.',
            nowCalling:
                'The system is currently communicating with the server.<br>Please try again later.',
            file: {
                name: 'Invalid file name.',
                encode: 'Invalid file encoding. (Only UTF-8 and Shift_JIS can be used)',
                format: 'invalid file format.(Only CSV format can be used)',
                columnCount: 'Invalid column count.',
                preprocessedColumCountFew:
                    'After preprocessing, there were not enough available data columns.<br>Please arrange the contents of the training data and try again.<br>For numeric columns with a small number of value types,<br>changing [0, 1, 2] to a string such as [A, B, C] may solve the problem.',
                preprocessedColumCountMany:
                    'Invalid column count for preprocessed data. <br>Please reduce the number of columns in data for learning and try again.',
                rowCount: 'Invalid row count.',
                dupuricateIndex: 'Dupulicate index.',
                dupuricateColumn: 'Dupulicate column name.',
                labelNa: 'There a label missing a value.',
                labelValue: 'There is a label including something other than 0 or 1.',
                allSameLabel: 'All labels have the same value',
                size: 'The file size exceeds the limit of 1 MB.',
                insufficientAll: 'The solution labels 1 (POS) and 0 (NEG) both contain no more than three rows of data.<br>Solution labels must be increased to at least four rows for both 1 (POS) and 0 (NEG).',
                insufficientPos: 'Solution label 1 (POS) contains no more than three rows of data.<br>Solution labels must be increased to at least four rows for both 1 (POS) and 0 (NEG).',
                insufficientNeg: 'Solution label 0 (NEG) contains no more than three rows of data.<br>Solution labels must be increased to at least four rows for both 1 (POS) and 0 (NEG).',
            },
            alreadyExec: 'Already executing.',
            predict: {
                unmatchColumn: "Column name doesn't match that used during learning.",
            },
            table: {
                noData: "Data doesn't exist.",
            },
        },
    },
    caseStudyCSV: {
        animals: {
            trainingText: "Identifying Mammals - Data for learning",
            predictionText: "Identifying Mammals - Data for prediction",
            headerText: "Name,Hair/fur,Wings,Oviparous,Flies,Aquatic,Eats meat,Teeth,Spine,Breathes using lungs,Fins,Legs,Tail,Bred by humans,Sized about the same as a cat?,Label",
        },
        election: {
            trainingText: "Election Case Study - Data for learning",
            predictionText: "Election Case Study - Data for prediction",
            headerText: "Name,Age,Gender,Political Party,Block,Number of Times Elected,New/Incumbent/Former,Birthplace = Electoral District,Hereditary Politician,Advocates Differing Family Names,Advocates Fiscal Discipline,Advocates Healthcare,Advocates Child Support,Advocates Welfare/Nursing,Advocates Employment/Labor,Advocates Pension,Decade Born,Month Born,Highest Education,Alma Mater,Faculty,Occuation,Hobbies,Elected",
        },
        covid: {
            trainingText: "COVID-19 Case Study - Data for learning",
            predictionTextA: "COVID-19 Case Study - Data A for prediction: When previously unimplemented policies are implemented",
            predictionTextB: "COVID-19 Case Study - Data B for prediction: When previously implemented policies are moved forward",
            headerText: "Country Base Date,[Characteristic] Region,[Characteristic] Vaccinated against BCG,[Characteristic] GDP per capita,[Characteristic] Over 65 years old,[Characteristic] Average life span,[Characteristic] Smokers,[Characteristic] Urban dwellers,[Characteristic] Wage earners,[Policy] School closing,[Policy] Restrictions on gatherings,[Policy] Workplace closing,[Policy] Stay at home requirements,[Policy] Restrict on internal movement,[Policy] Close public transport,[Policy] Cancel public events,Solution label",
        },
        defect_prevention: {
            trainingText: "Prevention of Defective Products - Data for learning",
            predictionText: "Prevention of Defective Products - Data for prediction",
            headerText: "ID,Production Line,Temperature,Pressure,Power,Amount of Chemical A,Amount of Chemical B,Rotation of K Axis,Rotation of J Axis,Defective",
        }
    },
    // vuetify 内部の定義
    $vuetify: {
        badge: 'Badge',
        close: 'Close',
        dataIterator: {
            noResultsText: 'No matching records found',
            loadingText: 'Loading items...',
        },
        dataTable: {
            itemsPerPageText: 'Rows per page:',
            ariaLabel: {
                sortDescending: 'Sort in descending order.',
                sortAscending: 'Sort in ascending order.',
                sortNone: 'Not sorted.',
                activateNone: 'Activate to remove sorting.',
                activateDescending: 'Activate to sort in descending order.',
                activateAscending: 'Activate to sort in ascending order.',
            },
            sortBy: 'Sort by',
        },
        dataFooter: {
            itemsPerPageText: 'Items per page:',
            itemsPerPageAll: 'All',
            nextPage: 'Next page',
            prevPage: 'Previous page',
            firstPage: 'First page',
            lastPage: 'Last page',
            pageText: '{0}-{1} of {2}',
        },
        datePicker: {
            itemsSelected: '{0} selected',
        },
        noDataText: 'No data available',
        carousel: {
            prev: 'Previous visual',
            next: 'Next visual',
            ariaLabel: {
                delimiter: 'Carousel slide {0} of {1}',
            },
        },
        calendar: {
            moreEvents: '{0} more',
        },
        fileInput: {
            counter: '{0} files',
            counterSize: '{0} files ({1} in total)',
        },
        timePicker: {
            am: 'AM',
            pm: 'PM',
        },
    },
};
